import { render, staticRenderFns } from "./outbound-webhooks.vue?vue&type=template&id=1882e718&"
import script from "./outbound-webhooks.vue?vue&type=script&lang=ts&"
export * from "./outbound-webhooks.vue?vue&type=script&lang=ts&"
import style0 from "./outbound-webhooks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports